
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';

interface NavLinkProps {
  to: string;
  icon: React.ReactNode;
  label: string;
}

const NavLink: React.FC<NavLinkProps> = ({ to, icon, label }) => {
  const location = useLocation();
  const isActive = location.pathname === to;
  
  return (
    <Link key={to} to={to}>
      <div
        className={cn(
          "flex items-center gap-2 px-3 py-2 relative group transition-all duration-300",
          isActive 
            ? "text-neon-purple" 
            : "text-gray-300 hover:text-neon-blue"
        )}
      >
        {/* Animated underline effect */}
        <span className={cn(
          "absolute bottom-0 left-0 h-[2px] bg-gradient-to-r from-transparent via-current to-transparent w-0 group-hover:w-full transition-all duration-300",
          isActive && "w-full"
        )} />
        
        {/* Icon with glow effect when active */}
        <span className={cn(
          "transition-all duration-300",
          isActive && "text-glow"
        )}>
          {icon}
        </span>
        
        {/* Label */}
        <span className={cn(
          "font-medium transition-all duration-300",
          isActive ? "font-semibold" : "text-opacity-80"
        )}>
          {label}
        </span>
      </div>
    </Link>
  );
};

export default NavLink;
